/** The voice ring as an arc on a 40 × 40 box, radius 18 (voice-ring.js). */
const C = 2 * Math.PI * 18

export function VoiceRingArc({ pct, className }: { pct: number; className?: string }) {
  const off = (C * (1 - Math.max(0, Math.min(1, pct)))).toFixed(1)
  return (
    <svg className={`vr-arc${className ? ` ${className}` : ''}`} viewBox="0 0 40 40" aria-hidden="true">
      <circle className="vr-arc__bg" cx="20" cy="20" r="18" />
      <circle className="vr-arc__fg" cx="20" cy="20" r="18" strokeDasharray={C.toFixed(1)} strokeDashoffset={off} transform="rotate(-90 20 20)" />
    </svg>
  )
}
